import React from 'react';
import { CreatePage } from '@components/common';
import ConsumptionForm from '@components/common/forms/ConsumptionForm';

const ConsumptionCreatePage = () => {
    return (
        <CreatePage
            modelName="consumptions"
            FormComponent={ConsumptionForm}
        />
    );
};

export default ConsumptionCreatePage;
